/** Canonical utility ordering; missing historical estimates stay unavailable. */
export function comparePriority(a: any, b: any, descending = true): number {
  if ((a.priority_tier ?? 2) !== (b.priority_tier ?? 2)) return (a.priority_tier ?? 2) - (b.priority_tier ?? 2);
  const left = a.priority_score;
  const right = b.priority_score;
  const missingLeft = left == null;
  const missingRight = right == null;
  if (missingLeft !== missingRight) return missingLeft ? 1 : -1;
  if (!missingLeft && left !== right) return (descending ? -1 : 1) * (left - right);
  return Number(a.internal_test_id) - Number(b.internal_test_id);
}
